import SectionBoard from 'model/SectionBoard';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';

type ZoneInfoModalProps = {
  info: SectionBoard | null;
  isOpen: boolean;
  onClose: () => void;
  posX: number;
  posY: number;
};

export default function ZoneInfoModal({
  info,
  isOpen,
  onClose,
  posX,
  posY,
}: ZoneInfoModalProps) {
  const { t } = useTranslation();
  const handlePopupOpen = () => {
    window.open(
      `/popup/zone-map/${info?.sectionId}`,
      '',
      'width=1400, height=1000, top=400, left=400',
    );
    onClose();
  };

  return (
    <ReactModal
      isOpen={isOpen}
      style={{
        content: {
          left: posX,
          top: posY,
          right: 'auto',
          bottom: 'auto',
          border: 0,
          padding: 0,
          background: '#000000',
          color: '#fff',
        },
      }}
      onRequestClose={onClose}
      overlayClassName={'ReactModal__Overlay__transparent'}
      id={'tooltip'}
    >
      <div id={'popup-wrap'} className={'tooltip'}>
        <div className={'popup-wrap'}>
          <div className={'popup-cont'}>
            {info && (
              <div className={'tt_tbl'}>
                <table>
                  <colgroup>
                    <col width={'25%'} />
                    <col width={'25%'} />
                    <col width={'25%'} />
                    <col width={'25%'} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td colSpan={4}>{info.sectionName}</td>
                    </tr>
                    <tr>
                      <th>{t('home.locking')}</th>
                      <th>{t('button.release')}</th>
                      <th className={'empty'} colSpan={2} rowSpan={2}>
            <button
              className={'btn_right'}
              type={'button'}
              onClick={handlePopupOpen}
            >
              {''}
            </button></th>
                    </tr>
                    <tr>
                      <td>{info.lockedTotal}</td>
                      <td>{info.unlockTotal}</td>
                    </tr>
                    <tr>
                      <th>{t('home.prod')}</th>
                      <th>{t('home.elec')}</th>
                      <th>{t('home.mech')}</th>
                      <th>{t('home.etc')}</th>
                    </tr>
                    <tr>
                      <td>{info.prodCompCnt}</td>
                      <td>{info.elecCompCnt}</td>
                      <td>{info.mecCompCnt}</td>
                      <td>{info.etcCompCnt}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

          </div>
        </div>
      </div>
    </ReactModal>
  );
}
